export default "__VITE_ASSET__BST92lRv__"